import React, { useState, useEffect } from "react";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Modal,
  IconButton,
  Box,
} from "@mui/material";
import useHttp from "../../Hooks/use-http";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";
import { FormatDateTime } from "../CommonComponent/DateFormat";
import { ReactComponent as AddSign } from "../../Assets/Plus_sign.svg";
import UpdateVerificationDocumentForPartner from "./UpdateVerificationDocumentForPartner";

const PartnerVerification = () => {
  const [documents, setDocuments] = useState([]);
  const [viewImage, setViewImage] = useState(null); // For modal image preview
  const [loading, setLoading] = useState(false);
  const [emailID, setEmailID] = useState(null);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [selectedDocID, setSelectedDocID] = useState(null);
  const [isRefresh, setIsRefresh] = useState(false);

  const { sendRequest } = useHttp();
  const history = useHistory();

  const location = useLocation();
  useEffect(() => {
    if (location.state && location.state.data) {
      setEmailID(location.state.data);
    }
  }, [location.state]);

  // ------------------------------------merging

  const [mergedDocuments, setMergedDocuments] = useState([]);

  useEffect(() => {
    sendRequest(
      {
        url: "/documentMergedData",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: localStorage.getItem("user"),
          data: {
            category: "Partner",
            emailID: emailID?.emailID,
          },
        },
      },
      documentDetails
    );
  }, [emailID, isRefresh]);

  // -----------------------------------------merging

  const documentDetails = (data) => {
    setMergedDocuments(data.mergedData);
  };

  console.log("Merged Documents for partner:", mergedDocuments);
  const handleVerify = async (docId, index) => {
    try {
      const approvedBy = localStorage.getItem("user");
      const approvedOn = new Date(
        new Date().getTime() + 5 * 60 * 60 * 1000 + 30 * 60 * 1000
      ).toISOString();

      // Get the current document from state
      const currentDoc = mergedDocuments[index];

      // Prepare the update data according to your backend expectations
      const updateData = {
        id: currentDoc.id, // This is CRUCIAL - must include the document's database ID
        documentID: currentDoc.documentID,
        documentNumber: currentDoc.documentNumber,
        url: currentDoc.url,
        isVerified: 1,
        approvedBy: approvedBy,
        approvedOn: approvedOn,
        emailID: emailID,
        category: currentDoc.category,
        // Include any other required fields that might be needed for validation
        ...(currentDoc.expiryDate && { expiryDate: currentDoc.expiryDate }),
      };

      // Update UI immediately
      const updatedDocuments = [...mergedDocuments];
      updatedDocuments[index] = {
        ...currentDoc,
        isVerified: 1,
        approvedBy,
        approvedOn,
        updatedAt: approvedOn,
      };
      setMergedDocuments(updatedDocuments);

      // Send to backend
      const response = await sendRequest({
        url: "/addupdatedocument",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: approvedBy,
          data: [updateData], // Your backend expects an array
        },
      });

      if (response.status === 200 || response.status === 201) {
        toast.success("Document verified successfully!");
        setIsRefresh(!isRefresh);
      } else {
        throw new Error(response.message || "Failed to verify document");
      }
    } catch (error) {
      toast.error(error.message);
      // Revert UI if API call fails
      const revertedDocuments = [...mergedDocuments];
      setMergedDocuments(revertedDocuments);
    }
  };

  const handleUpdateSuccess = () => {
    setIsRefresh((prev) => !prev); // trigger useEffect to re-call /documentMergedData
  };
  return (
    <div style={{ padding: "20px" }}>
      <h4>Verification Documents</h4>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Document ID</TableCell>
            <TableCell>Document Number</TableCell>
            <TableCell>Document Name</TableCell>

            <TableCell>Image</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>UpdateAt</TableCell>

            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {mergedDocuments?.length === 0 ? (
            <TableRow>
              <TableCell colSpan={5}>
                <h2>No Documents</h2>
              </TableCell>
            </TableRow>
          ) : (
            mergedDocuments?.map((doc, index) => {
              const isIncomplete = !doc.url || !doc.documentNumber;

              return (
                <TableRow key={doc.documentID}>
                  <TableCell>{doc.documentID}</TableCell>
                  <TableCell>{doc.documentNumber}</TableCell>
                  <TableCell>{doc.documentName}</TableCell>

                  <TableCell>
                    {doc.url ? (
                      // Check if URL ends with common image extensions
                      doc.url.match(/\.(jpeg|jpg|gif|png)$/) ? (
                        <img
                          src={doc.url}
                          alt="Document"
                          style={{ width: "100px", cursor: "pointer" }}
                          onClick={() => setViewImage(doc.url)}
                        />
                      ) : (
                        // For PDFs or other file types, show a clickable link/icon
                        <div
                          style={{ cursor: "pointer", color: "blue" }}
                          onClick={() => window.open(doc.url, "_blank")}
                        >
                          View
                        </div>
                      )
                    ) : (
                      "No File"
                    )}
                  </TableCell>

                  <TableCell>
                    {doc?.isVerified ? "Verified" : "Pending"}
                  </TableCell>
                  <TableCell>{FormatDateTime(doc.updatedAt)}</TableCell>

                  <TableCell>
                    {/* If document is complete, show both buttons */}
                    {!isIncomplete ? (
                      <div style={{ display: "flex", gap: "5px" }}>
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          disabled={
                            doc?.isVerified == null || doc?.isVerified === 1
                          }
                          onClick={() => handleVerify(doc.documentID, index)}
                          style={{ marginRight: "8px" }}
                        >
                          Verify
                        </Button>

                        <IconButton
                          onClick={() => {
                            setSelectedDocID(doc.documentID);
                            setIsUpdateModalOpen(true);
                          }}
                        >
                          {/* <AddIcon /> */}
                          <AddSign />
                        </IconButton>
                      </div>
                    ) : (
                      <IconButton
                        onClick={() => {
                          setSelectedDocID(doc.documentID);
                          setIsUpdateModalOpen(true);
                        }}
                      >
                        {/* <AddIcon /> */}
                        <AddSign />
                      </IconButton>
                    )}
                  </TableCell>
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>

      {/* Modal for viewing image */}
      <Modal open={!!viewImage} onClose={() => setViewImage(null)}>
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            padding: "20px",
            boxShadow: 24,
            borderRadius: "8px",
            width: "40%",
            position: "relative", // Keep the position relative to ensure correct placement of the button
          }}
        >
          {/* <div style={{ position: "relative" }}> */}
          <img
            src={viewImage}
            alt="Document Preview"
            style={{ width: "50%", height: "50%" }}
          />

          <Button
            onClick={() => setViewImage(null)}
            style={{
              color: "red",
              background: "none",
              border: "none",
              fontSize: "16px",
              cursor: "pointer",
            }}
          >
            X
          </Button>

          {/* </div> */}
        </Box>
      </Modal>

      {isUpdateModalOpen && (
        <UpdateVerificationDocumentForPartner
          open={isUpdateModalOpen}
          onClose={() => setIsUpdateModalOpen(false)}
          emailID={emailID}
          documentss={documents}
          documentID={selectedDocID}
          onSuccess={handleUpdateSuccess}
        />
      )}
    </div>
  );
};

export default PartnerVerification;
